var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferHot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Product_Beverage_Hot_Solid-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.084,
    height: 28.125,
    viewBox: "0 0 20.084 28.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M23.685,13.343a.265.265,0,0,0-.261-.227H21.149L20.211,10.2a.257.257,0,0,0-.248-.181H8.634a.257.257,0,0,0-.248.181l-.938,2.915H5.084a.265.265,0,0,0-.261.236l-.555,4.627a.265.265,0,0,0,.265.294H24.089a.261.261,0,0,0,.257-.311Zm-2.945,2.8H15.81a.37.37,0,0,1,0-.74h4.947a.37.37,0,1,1,0,.74Z",
    transform: "translate(-4.266 -10.02)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M8.713,49.815A.286.286,0,0,0,9,50.071H24.366a.446.446,0,0,1,.08,0l.5-4.842a.286.286,0,0,0-.286-.32H8.5a.294.294,0,0,0-.29.32Z",
    transform: "translate(-6.55 -30.234)",
    fill: "#ed8b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M9.748,59.26l.761,6.966a.294.294,0,0,0,.29.261H24.261a.286.286,0,0,0,.286-.261l.736-7.286H10.034a.29.29,0,0,0-.286.32Z",
    transform: "translate(-7.441 -38.362)",
    fill: "#ed8b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M7.609,36.858H24.04a.286.286,0,0,0,.286-.257l.421-3.992a.29.29,0,0,0-.286-.32l-17.247.046a.29.29,0,0,0-.286.32L7.349,36.6A.286.286,0,0,0,7.609,36.858Z",
    transform: "translate(-5.807 -22.922)",
    fill: "#ed8b00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferHot);
export default __webpack_public_path__ + "static/media/offer_hot.4c7b4ba7f52f59201fe49739f7d0ff53.svg";
export { ForwardRef as ReactComponent };